export default {
  INITIALIZED: 'INITIALIZED',
  IN_PROGRESS: 'IN PROGRESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
}
